import jsPDF from "jspdf";
import { format } from "date-fns";

export const generateTokenPDF = (service, tokenData, settingData) => {
  const doc = new jsPDF();

  // Get page dimensions for centering
  const pageWidth = doc.internal.pageSize.getWidth();

  // Compact layout - reduced vertical spacing
  let yPosition = 20; // Starting vertical position

  const addCenteredText = (text, fontSize = 12) => {
    doc.setFontSize(fontSize);
    const textWidth = doc.getTextWidth(text);
    doc.text(text, 10, yPosition);
    yPosition += 10; // Adjust line height
  };

  // Add content

  // add logo
  const logo = settingData?.logo_image;
  const logoUrl = `${process.env.REACT_APP_UPLOAD_URL}/${logo}`;

  if (logo) {
    doc.addImage(logoUrl, "PNG", 40, 1, 10, 10, undefined, "FAST");
  }

  addCenteredText(settingData?.website_name, 16);
  addCenteredText(`Date: ${format(new Date(), "dd MMM yyyy p")}`, 12);

  addCenteredText(`Token No: ${tokenData?.token}`, 20);

  addCenteredText(`Service: ${service.name}`, 14);
  addCenteredText("Please wait for your turn", 14);

  // Open the print dialog
  // doc.autoPrint();
  // window.open(doc.output("bloburl"), "_blank");
  // Generate the PDF as a Blob URL
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);

  // Create a hidden iframe and append it to the document
  const iframe = document.createElement("iframe");
  iframe.style.display = "none"; // Hide the iframe
  iframe.src = pdfUrl;

  // Append the iframe to the body
  document.body.appendChild(iframe);

  // Wait for the iframe to load and then call the print function
  iframe.onload = () => {
    iframe.contentWindow?.print();
  };
};
